import { Navigate } from "react-router-dom";
import routes from "../routes";
import { useGetUser } from "./QueueUtil";

export default function DefaultPageRouter() {
  const user = useGetUser();
  if (!user) {
    return null;
  } else if (user?.roles?.includes("qmAssigner")) {
    return <Navigate replace to={routes.SUPERVISOR_DASHBOARD} />;
  } else {
    return <Navigate replace to={routes.DASHBOARD} />;
  }
}
